import React from "react";
import PropTypes from "prop-types";
import { TabsContainer, Tabs, Tab } from "react-md/lib/Tabs";
import Card from "react-md/lib/Cards/Card";
import CardText from "react-md/lib/Cards/CardText";
import SelectField from "react-md/lib/SelectFields";
import Button from "react-md/lib/Buttons";
import LinkDuo from "components/LinkDuo";
import { TextField } from "components/Shared";
import { EmptyCard } from "components/Shared/EmptyCard";
import HistoryCards from "components/Homeowner/CaseDetails/HistoryCards";
import webConfig from "middlewares/WebConfig";

const RemarksCards = ({ remark }) => {
    return (
        <div className="details-notes">
            {remark ?
                <Card className="md-block-centered">
                    <CardText>
                        <TextField field={remark} />
                    </CardText>
                </Card>
                : EmptyCard()}
        </div>
    );
};
RemarksCards.propTypes = {
    remark: PropTypes.string
};

function CaseHistoryTabWrapper(props) {
    const caseHistory = props.caseHistory;
    return (
        <TabsContainer colored panelClassName="md-grid">
            <Tabs tabId="notes" alignToKeyline={false}>
                <Tab label="All"><HistoryCards notes={caseHistory.allNotes} /></Tab>
                <Tab label="Touches"><HistoryCards notes={caseHistory.touches} /></Tab>
                <Tab label="CS Notes"><HistoryCards notes={caseHistory.csNotes} /></Tab>
                <Tab label="Call Log"><HistoryCards notes={caseHistory.callLog} /></Tab>
                <Tab label="Case Issues"><HistoryCards notes={caseHistory.issues} /></Tab>
            </Tabs>
        </TabsContainer>
    );
}

CaseHistoryTabWrapper.propTypes = {
    caseHistory: PropTypes.object.isRequired
};

function CaseRemarksTabWrapper(props) {
    const caseRemarks = props.caseRemarks;
    return (
        <TabsContainer colored panelClassName="md-grid">
            <Tabs tabId="notes" alignToKeyline={false}>
                <Tab label="Survey Remarks"><RemarksCards remark={caseRemarks.surveyRemarks} /></Tab>
                <Tab label="Private Notes"><RemarksCards remark={caseRemarks.privateNotes} /></Tab>
                <Tab label="Close Out Notes"><RemarksCards remark={caseRemarks.closeOutNotes} /></Tab>
                <Tab label="Appointment Directions"><RemarksCards remark={caseRemarks.appointmentDirections} /></Tab>
            </Tabs>
        </TabsContainer>
    );
}

CaseRemarksTabWrapper.propTypes = {
    caseRemarks: PropTypes.object.isRequired
};

const CaseNotesHeader = ({ menuItems, switchMenuItem, controlNumber, token }) => {
    return (
        <div className="details-notes-header">
            <div className="md-grid">
                <SelectField
                    id="selectButtonLinks"
                    placeholder={menuItems[0].desc}
                    menuItems={menuItems}
                    onChange={switchMenuItem}
                    itemLabel="desc"
                    itemValue="id"
                    position={SelectField.Positions.BELOW}
                    className="md-cell"
                />
                <div className="details-case-button">
                    <LinkDuo
                        to={`${webConfig.caseUrlTemplate}${controlNumber}`}
                        token={token}>
                        <Button
                            raised
                            primary
                            iconBefore={false}
                            label="Go To Case"
                            iconClassName="material-icons">navigate_next
                        </Button>
                    </LinkDuo>
                </div>
            </div>
        </div>
    );
};
CaseNotesHeader.propTypes = {
    menuItems: PropTypes.array.isRequired,
    switchMenuItem: PropTypes.func.isRequired,
    controlNumber: PropTypes.string.isRequired,
    token: PropTypes.string.isRequired
};

export {
    CaseNotesHeader,
    CaseHistoryTabWrapper,
    CaseRemarksTabWrapper
};